import { render, staticRenderFns } from "./transactionInfo.vue?vue&type=template&id=7bd0fcc4&scoped=true&"
import script from "./transactionInfo.vue?vue&type=script&lang=ts&"
export * from "./transactionInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd0fcc4",
  null
  
)

export default component.exports